import React, { CSSProperties } from 'react'
import { TextField, Label } from '@hospitalrun/components'
import classes from '../../style.module.scss'

interface Props {
  value: string
  label: string
  name: string
  isEditable?: boolean
  placeholder?: string
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  isRequired?: boolean
  feedback?: string
  isInvalid?: boolean
  style?: CSSProperties
}

const TextFieldWithLabelFormGroup = (props: Props) => {
  const { value, label, name, isEditable, isInvalid, isRequired, feedback, onChange, style } = props
  const id = `${name}TextField`
  return (
    <div className="form-group">
      <Label
        className={classes.label}
        text={label}
        htmlFor={id}
        isRequired={isRequired && isEditable}
      />
      {isEditable ? (
        <TextField
          style={style}
          rows={4}
          value={value}
          disabled={!isEditable}
          onChange={onChange}
          isInvalid={isInvalid}
          feedback={feedback}
        />
      ) : (
        <div>
          <pre className="text-secondary">{value}</pre>
          <br />
          <br />
        </div>
      )}
    </div>
  )
}

TextFieldWithLabelFormGroup.defaultProps = {
  value: '',
}

export default TextFieldWithLabelFormGroup
